<template>
    <div class="sustainable-component super-admin-permissions">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-permission</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa rättighet" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="PermissionLevel" :rules="[rules.required]" v-model="selectedPermissionLevel" id="permissionLevel" item-title="name" item-value="value" :items="permissionLevels" label="Rättighetsnivå">

                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="PermissionType" :rules="[rules.required]" v-model="selectedPermissionType" id="permissionType" item-title="name" item-value="value" :items="permissionTypes" label="Funktion">

                                                    </v-select>

                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col">

                                                    <v-select name="Department" v-model="departmentId" id="department" item-title="DepartmentName" item-value="DepartmentId" :items="departments" label="Avdelning">

                                                    </v-select>

                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="permission" :rules="[rules.required]" v-model="selectedPermission" id="permission" item-title="name" item-value="value" :items="readorwritepermissions" label="Rättighet">

                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-btn variant="tonal" @click="createPermission" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{permissions.length}} rättigheter</b>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Rättighetsnivå</th>
                            <th class="col-4">Funktion</th>
                            <th class="col-2">Läs</th>
                            <th class="col-2">Skriv</th>
                            <th class="col-2">Avd.</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in permissions" :key="index">
                            <td>{{getPermissionLevel(item.PermissionLevel)}}</td>
                            <td>{{item.PermissionType}}</td>
                            <td class="p-0 px-2"><v-checkbox density="compact" v-model="item.ReadPermission" hide-details disabled></v-checkbox></td>
                            <td class="p-0 px-3"><v-checkbox density="compact" v-model="item.WritePermission" hide-details disabled></v-checkbox></td>
                            <td>{{getDepartmentnameFromId(item.DepartmentId)}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deletePermission(item.PermissionId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import CommonSpinner from '../../common/common-spinner.vue'

    import { ref } from 'vue'
    const form = ref(null);

    export default {

        name: 'super-admin-permissions',
        props: {

        },
        components: {
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            getDepartmentnameFromId(id) {
                var depName = "Hittades inte";
                for (var i = 0; i < this.departments.length; i++) {
                    if (this.departments[i].DepartmentId == id)
                        depName = this.departments[i].DepartmentName;
                }
                return depName;
            },
            getPermissionLevel(level) {
                for (var i = 0; i < this.permissionLevels.length; i++) {
                    if (this.permissionLevels[i].value.toString() == level.toString()) {
                        return this.permissionLevels[i].name;
                    }
                }
                return "Odefinierat";
            },
            async loadDepartments() {
                this.loading++;
                try {
                    var departments = [{ DepartmentName: 'Ingen vald', DepartmentId: null }, ...await AdminService.getDepartments()];
                    this.departments = departments;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async createPermission() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;

                if(this.selectedPermission == 1)
                {
                    this.readPermission = true;
                    this.writePermission = false;
                }
                else if(this.selectedPermission == 2){
                    this.readPermission = true
                    this.writePermission = true;
                }
                else{
                    this.readPermission = false
                    this.writePermission = false;
                }

                this.modifyPermission = false;

                try {
                    await AdminService.addPermissionForDepartment(this.selectedPermissionLevel, this.selectedPermissionType, this.readPermission, this.writePermission, this.modifyPermission, this.departmentId);
                    this.displaySnackBar("Rättigheten skapades");
                    this.loadPermissions();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;

            },
            async loadPermissions() {
                this.loading++;
                try {
                    this.permissions = await AdminService.getAllPermissions();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async deletePermission(permissionId) {
                if (confirm("Är du säker att du vill radera rättigheten?")) {
                    this.loading++;
                    try {
                        await AdminService.deletePermission(permissionId);
                        this.displaySnackBar("Rättigheten togs bort");
                        this.loadPermissions();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                permissions: [],
                //permissionLevels: [{ name: "Avdelningsadmin", value: "15" }, { name: "Admin", value: "20" }, { name: "Användare", value: "30" }, { name: "Läsare", value: "40" }],
                permissionLevels: [{ name: "Användare", value: "30" }, { name: "Läsare", value: "40" }],
                readorwritepermissions: [{ name: "Ingen", value: "0" },{ name: "Läs", value: "1" }, { name: "Läs och skriv", value: "2" }],
                permissionTypes: [
                    { name: "Arbetsorganisation", value: "Arbetsorganisation" },
                    { name: "Arbetsorganisation - Översikt", value: "Arbetsorganisation - Översikt" },
                    { name: "Arbetsorganisation - Definiera befattningar", value: "Arbetsorganisation - Definiera befattningar" },
                    { name: "Arbetsorganisation - Arbetsinnehåll och utveckling", value: "Arbetsorganisation - Arbetsinnehåll och utveckling" },
                    { name: "Arbetsorganisation - Utvecklingsblock", value: "Arbetsorganisation - Utvecklingsblock" },
                    { name: "Arbetsorganisation - Fördela arbetsuppgifter", value: "Arbetsorganisation - Fördela arbetsuppgifter" },
                    { name: "Arbetsorganisation - Arbetsbeskrivning", value: "Arbetsorganisation - Arbetsbeskrivning" },


                    { name: "Lönesättning", value: "Lönesättning" },
                    { name: "Lönesättning - Översikt", value: "Lönesättning - Översikt" },
                    { name: "Lönesättning - Lönestapeln", value: "Lönesättning - Lönestapeln" },
                    { name: "Lönesättning - Värdera grundarbetet", value: "Lönesättning - Värdera grundarbetet" },
                    { name: "Lönesättning - Värdera utvecklingsblock", value: "Lönesättning - Värdera utvecklingsblock" },
                    { name: "Lönesättning - Individuella tillägg", value: "Lönesättning - Individuella tillägg" },
                    { name: "Lönesättning - Rörlig lönedel", value: "Lönesättning - Rörlig lönedel" },
                    { name: "Lönesättning - Inplacering av individer", value: "Lönesättning - Inplacering av individer" },
                    { name: "Lönesättning - Pengar i systemet", value: "Lönesättning - Pengar i systemet" },
                    { name: "Lönesättning - Resultatet", value: "Lönesättning - Resultatet" },

                    { name: "Jämställdhet", value: "Jämställdhet" },
                    { name: "Jämställdhet - Översikt", value: "Jämställdhet - Översikt" },
                    { name: "Jämställdhet - Könsfördelning", value: "Jämställdhet - Könsfördelning" },
                    { name: "Jämställdhet - Möjligheter till utveckling i arbetet", value: "Jämställdhet - Möjligheter till utveckling i arbetet" },
                    { name: "Jämställdhet - Lika lön för lika arbete", value: "Jämställdhet - Lika lön för lika arbete" },
                    { name: "Jämställdhet - Lika lön för likvärdigt arbete", value: "Jämställdhet - Lika lön för likvärdigt arbete" },
                    { name: "Jämställdhet - Resultat", value: "Jämställdhet - Resultat" },

                    { name: "Kompetens", value: "Kompetens" },
                    { name: "Kompetens - Översikt", value: "Kompetens - Översikt" },
                    { name: "Kompetens - Arbetsorganisation", value: "Kompetens - Arbetsorganisation" },
                    { name: "Kompetens - Anställda", value: "Kompetens - Anställda" },
                    { name: "Kompetens - Regelverk", value: "Kompetens - Regelverk" },
                    { name: "Kompetens - Revision", value: "Kompetens - Revision" },
                    { name: "Kompetens - Utvecklingsplan", value: "Kompetens - Utvecklingsplan" },
                    { name: "Kompetens - Kompetensmatris", value: "Kompetens - Kompetensmatris" },

                    { name: "Admin", value: "Admin" },
                    { name: "Rapport", value: "Rapport" }],
                selectedPermissionType: null,
                selectedPermissionLevel: null,
                selectedPermission:0,
                readPermission: false,
                writePermission: false,
                modifyPermission: false,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                loading: 0,
                departments: [],
                departmentId:null
            };
        },
        watch: {

        },
        async mounted() {
            await this.loadDepartments();
            this.loadPermissions();

        },
        setup() {
            return { form }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>